export default "__VITE_ASSET__CntlaaRP__"